/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Component, defineComponent, onMounted } from 'vue';
import StudyListingOverviewComponent from '@/presentation/pages/listing/study-listing-overview/study-listing-overview-class';
import ListingOverview from '@/presentation/components/listing-overview/listing-overview.vue';

export default defineComponent({
	components: {
		ListingOverview: ListingOverview as Component
	},
	setup: () => {
		const component = new StudyListingOverviewComponent();

		onMounted(component.mounted.bind(component));

		return {
			campaignId: component.campaignId
		};
	}
});
